export default __webpack_public_path__ + "static/media/Connection.fff0bfe1.webp";